import { ChangeDetectionStrategy, Component, computed, input, resource } from '@angular/core'
import { DomSanitizer, SafeHtml } from '@angular/platform-browser'
import { TuettuKieli } from '@lemon/core/model/common'

import { KirjanpitajanAllekirjoitusService } from 'app/_jaettu-lemonator/service/kirjanpitajan-allekirjoitus.service'
import { KirjanpitajanNimitiedot } from '../_jaettu-lemonator/model/kirjanpitaja'

@Component({
  selector: '[app-kirjanpito-lahetys-signature]',
  template: '<div [innerHTML]="signatureHtml()"></div>@if (naytaRawHtml()) {<div><pre>{{ signatureHtmlString.value() }}</pre></div>}', // To render out as text, append "<div><pre>{{ signatureHtmlString.value() }}</pre></div>" without quotes
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class KirjanpitoLahetysSignatureComponent {
  // Inputs for the component
  kirjanpitajanNimitiedot = input<KirjanpitajanNimitiedot>(null)
  kieli = input<TuettuKieli>('fi')
  naytaRawHtml = input<boolean>(false)

  // The raw signature HTML string
  signatureHtmlString = resource<string, { nimitiedot: KirjanpitajanNimitiedot; kieli: TuettuKieli }>({
    params: () => ({ nimitiedot: this.kirjanpitajanNimitiedot(), kieli: this.kieli() }),
    loader: async ({ params, abortSignal, previous }) => {
      if (!params.nimitiedot || !params.kieli) {
        return ''
      }
      return this._kirjanpitajanAllekirjoitusService.getSignatureHtml(params.nimitiedot, params.kieli)
    },
    defaultValue: '',
  })

  // Bypassed security to directly render the HTML
  signatureHtml = computed<SafeHtml>(() => {
    return this._domSanitizer.bypassSecurityTrustHtml(this.signatureHtmlString.value())
  })

  constructor(
    private _kirjanpitajanAllekirjoitusService: KirjanpitajanAllekirjoitusService,
    private _domSanitizer: DomSanitizer,
  ) {}
}
